
export const richToolbar = [
  {
    id: 'format__header_two',
    btnComp: 'ButtonPrimaryV2',
    icon: 'LetterH',
    tooltipText: 'Title Text',
    onClickHandler: 'applyBlockFormatting',
    clickHandlerArgs: [
      'header-four'
    ],
    textFormatBlock: true
  },
  {
    id: 'format__unordered_list_item',
    btnComp: 'ButtonPrimaryV2',
    icon: 'ListDashes',
    tooltipText: 'Bullet List',
    onClickHandler: 'applyBlockFormatting',
    clickHandlerArgs: [
      'unordered-list-item' //block format style
    ],
    textFormatBlock: true
  },
  {
    id: 'format__ordered_list_item',
    btnComp: 'ButtonPrimaryV2',
    icon: 'ListNumbers',
    tooltipText: 'Numbered List',
    onClickHandler: 'applyBlockFormatting',
    clickHandlerArgs: [
      'ordered-list-item'
    ],
    textFormatBlock: true
  },
  {
    id: 'format__blockquote',
    btnComp: 'ButtonPrimaryV2',
    icon: 'Quotes',
    tooltipText: 'Pull Quote',
    onClickHandler: 'applyBlockFormatting',
    clickHandlerArgs: [
      'blockquote'
    ],
    textFormatBlock: true
  },
  {
    id: 'upload__inline_image',
    btnComp: 'ButtonUpload',
    icon: 'ImageSquare',
    tooltipText: 'Insert Image',
    multiple: false,
    onChangeHandler: 'handleUploadChange',
    changeHandlerArgs: [
      'KPRichInlineImage', //comp to render
      `images`, //folderName
      ['jpg', 'jpeg', 'png'] //allowedFormats
    ],
    imageBlock: true
  },
  {
    id: 'upload__inline_pdf',
    btnComp: 'ButtonUpload',
    icon: 'FilePdf',
    tooltipText: 'Insert PDF',
    multiple: false,
    onChangeHandler: 'handleUploadChange',
    changeHandlerArgs: [
      'KPPDFDisplay',
      `pdfs`,
      ['pdf']
    ]
  },
  {
    id: 'atomic__video_embed',
    btnComp: 'ButtonPrimaryV2',
    icon: 'VideoCamera',
    tooltipText: 'Embed Video',
    onClickHandler: 'createAtomicBlockEntity',
    clickHandlerArgs: [
      'KPVideoEmbed'
    ]
  },
  {
    id: 'atomic__audio_embed',
    btnComp: 'ButtonPrimaryV2',
    icon: 'SpeakerSimpleHigh',
    tooltipText: 'Embed Audio',
    onClickHandler: 'createAtomicBlockEntity',
    clickHandlerArgs: [
      'AudioEmbed'
    ]
  },
  {
    id: 'atomic__card_link',
    advancedBlock: true,
    title: 'Embed Content Cards',
    desc: 'Embed cards that link to other stories, tools, profiles, (anything really on this platform really! ). You can embed external links as well.',
    onClickHandler: 'handleShowCardLinkInput',
    clickHandlerArgs: [] //meed to pass an empty array for no args, else well have an error
  },
  {
    id: 'atomic__ppt_embed',
    advancedBlock: true,
    title: 'Embed Google Slides',
    desc: 'Use this to embed a google slide presentation within your contribution. A user will be able to interact with it, without having to this page.',
    onClickHandler: 'createAtomicBlockEntity',
    clickHandlerArgs: [
      'KPPPTEmbed'
    ]
  },
  {
    id: 'atomic__call_to_action',
    advancedBlock: true,
    title: 'Add A Call To Action Button',
    desc: 'Lorem Ipsum.',
    onClickHandler: 'handleShowLinkInput',
    clickHandlerArgs: []
  },
  {
    id: 'atomic__contact_channels',
    advancedBlock: true,
    title: 'Add Contact Channels Component',
    desc: 'Lorem Ipsum.',
    onClickHandler: 'createAtomicBlockEntity',
    clickHandlerArgs: [
      "KPLikeContactChannelsBlock"
    ]
  }

]
